/* Everstride reference draft — storefront behaviour (no dependencies). */
(function () {
  'use strict';
  var cfg = window.esTheme || {};
  var routes = cfg.routes || {};
  var strings = cfg.strings || {};

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || cfg.moneyFormat || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmtNum(n, prec, thou, dec) {
      thou = thou === undefined ? ',' : thou; dec = dec === undefined ? '.' : dec;
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(prec);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return d + (parts[1] ? dec + parts[1] : '');
    }
    var v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = fmtNum(cents, 0); break;
      case 'amount_with_comma_separator': v = fmtNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmtNum(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmtNum(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmtNum(cents, 2, ' ', ','); break;
      default: v = fmtNum(cents, 2);
    }
    return m ? fmt.replace(m[0], v) : v;
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function json(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin' }, opts || {}))
      .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) { var e = new Error(d.description || d.message || 'Error'); e.data = d; throw e; } return d; }); });
  }
  window.esFormatMoney = formatMoney;

  /* ---------- dialogs ---------- */
  function openDialog(d) { if (!d) return; if (typeof d.showModal === 'function') { if (!d.open) d.showModal(); } else d.setAttribute('open', ''); }
  function closeDialog(d) { if (!d) return; if (typeof d.close === 'function') d.close(); else d.removeAttribute('open'); }
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-es-open]');
    if (op) { var d = document.getElementById(op.getAttribute('data-es-open')); if (d) { e.preventDefault(); openDialog(d); } return; }
    var cl = e.target.closest('[data-es-close]');
    if (cl) { closeDialog(cl.closest('dialog')); return; }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('es-dialog')) {
      var r = e.target.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside || e.target.classList.contains('es-menu')) closeDialog(e.target);
    }
  });

  /* ---------- gallery ---------- */
  function initGallery(root) {
    if (root.dataset.esReady) return; root.dataset.esReady = '1';
    var slides = root.querySelectorAll('.es-gallery__slide');
    var thumbs = root.querySelectorAll('.es-thumb');
    var count = root.querySelector('[data-es-count]');
    var i = 0;
    function go(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); if (k !== i) { var v = s.querySelector('video'); if (v) v.pause(); } });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = root.querySelector('[data-es-prev]'), next = root.querySelector('[data-es-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    go(0);
  }

  /* ---------- product cards: swatch switches image ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.es-swatch[data-img]');
    if (!sw) return;
    var card = sw.closest('[data-es-card]');
    if (!card) return;
    card.querySelectorAll('.es-swatch').forEach(function (s) { s.setAttribute('aria-pressed', s === sw ? 'true' : 'false'); });
    var img = card.querySelector('.es-card__media img');
    if (img && sw.dataset.img) { img.removeAttribute('srcset'); img.src = sw.dataset.img; }
    var links = card.querySelectorAll('a[data-base]');
    links.forEach(function (a) { a.href = a.dataset.base + (sw.dataset.variant ? '?variant=' + sw.dataset.variant : ''); });
  });

  /* ---------- cart ---------- */
  var Cart = {
    drawer: function () { return document.getElementById('EsCartDrawer'); },
    setCount: function (n) {
      document.querySelectorAll('[data-es-cart-count]').forEach(function (b) { b.textContent = n; b.hidden = !n; });
      document.querySelectorAll('[data-es-cart-title-count]').forEach(function (b) { b.textContent = n; });
    },
    msg: function (t) { var m = document.querySelector('[data-es-cart-msg]'); if (m) m.textContent = t || ''; },
    render: function (cart) {
      var d = this.drawer(); if (!d) return;
      this.setCount(cart.item_count);
      var body = d.querySelector('[data-es-cart-lines]');
      var foot = d.querySelector('[data-es-cart-foot]');
      var empty = d.querySelector('[data-es-cart-empty]');
      if (!cart.items.length) { body.innerHTML = ''; empty.hidden = false; foot.hidden = true; return; }
      empty.hidden = true; foot.hidden = false;
      body.innerHTML = cart.items.map(function (it, idx) {
        var line = idx + 1;
        var img = it.image ? '<img src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=176') + '" alt="' + esc(it.product_title) + '" width="88" height="88" loading="lazy">' : '';
        var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' · ');
        var props = '';
        var orig = it.original_line_price > it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '';
        var discs = (it.line_level_discount_allocations || []).map(function (a) { return '<span class="es-line__opts">' + esc(a.discount_application ? a.discount_application.title : '') + '</span>'; }).join('');
        return '<div class="es-line" data-line="' + line + '">' +
          '<a class="es-line__img" href="' + esc(it.url) + '" tabindex="-1">' + img + '</a>' +
          '<div class="es-line__info"><div class="es-line__top"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          '<button type="button" class="es-iconbtn" data-es-remove="' + line + '" aria-label="' + esc(strings.remove || 'Remove') + ' ' + esc(it.product_title) + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#585858" stroke-width="1.8" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg></button></div>' +
          (opts ? '<span class="es-line__opts">' + opts + '</span>' : '') + props + discs +
          '<div class="es-line__bottom"><div class="es-qty"><button type="button" data-es-qty="' + line + '" data-q="' + (it.quantity - 1) + '" aria-label="' + esc(strings.decrease || 'Decrease quantity') + '">&minus;</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-es-qty="' + line + '" data-q="' + (it.quantity + 1) + '" aria-label="' + esc(strings.increase || 'Increase quantity') + '">+</button></div>' +
          '<div class="es-line__price">' + orig + '<span>' + formatMoney(it.final_line_price) + '</span></div></div></div></div>';
      }).join('');
      var disc = d.querySelector('[data-es-cart-discount-row]');
      if (disc) { disc.hidden = !(cart.total_discount > 0); var dv = disc.querySelector('[data-es-cart-discount]'); if (dv) dv.textContent = '− ' + formatMoney(cart.total_discount); }
      var tot = d.querySelector('[data-es-cart-total]'); if (tot) tot.textContent = formatMoney(cart.total_price);
    },
    refresh: function () { var self = this; return json(routes.cart || '/cart.js').then(function (c) { self.render(c); return c; }); },
    change: function (line, qty) {
      var self = this, d = this.drawer(); if (d) d.classList.add('es-busy'); self.msg('');
      return json(routes.cartChange || '/cart/change.js', { method: 'POST', body: JSON.stringify({ line: line, quantity: Math.max(0, qty) }) })
        .then(function (c) { self.render(c); })
        .catch(function (e) { self.msg(e.message || strings.error); return self.refresh(); })
        .finally(function () { if (d) d.classList.remove('es-busy'); });
    },
    open: function () { var self = this; openDialog(this.drawer()); return this.refresh().catch(function () { self.msg(strings.error); }); }
  };
  window.esCart = Cart;
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-es-cart-open]');
    if (o && Cart.drawer()) { e.preventDefault(); Cart.open(); return; }
    var q = e.target.closest('[data-es-qty]');
    if (q) { Cart.change(parseInt(q.dataset.esQty, 10), parseInt(q.dataset.q, 10)); return; }
    var r = e.target.closest('[data-es-remove]');
    if (r) { Cart.change(parseInt(r.dataset.esRemove, 10), 0); }
  });

  /* ---------- product form: pairs, variants, add to cart ---------- */
  function initProduct(root) {
    if (root.dataset.esReady) return; root.dataset.esReady = '1';
    var gal = root.querySelector('[data-es-gallery]'); if (gal) initGallery(gal);
    var dataEl = root.querySelector('[data-es-product-json]');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var pairsBox = root.querySelector('[data-es-pairs]');
    var tpl = root.querySelector('template[data-es-pair-tpl]');
    var atc = root.querySelector('[data-es-atc]');
    var msg = root.querySelector('[data-es-msg]');
    var priceEl = root.querySelector('[data-es-price-sale]');
    var cmpEl = root.querySelector('[data-es-price-compare]');
    var tiers = root.querySelectorAll('[data-es-tier]');
    var pairLabel = root.dataset.pairLabel || 'Pair';
    var initial = product ? JSON.parse(root.dataset.initialOptions || '[]') : [];
    var labels = { add: atc ? atc.dataset.labelAdd : '', sold: atc ? atc.dataset.labelSoldout : '', unavailable: atc ? atc.dataset.labelUnavailable : '' };
    var state = [];
    var curTier = tiers.length ? (root.querySelector('[data-es-tier][aria-pressed="true"]') || tiers[0]) : null;
    var free = curTier ? (parseInt(curTier.dataset.esFree, 10) || 0) : 0;
    var qty = curTier ? (parseInt(curTier.dataset.esTier, 10) || 1) + free : 1;

    function findVariant(opts) {
      if (!product) return null;
      if (product.variants.length === 1 && product.has_only_default_variant !== false && opts.length === 0) return product.variants[0];
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function rowOptions(row) { return Array.prototype.map.call(row.querySelectorAll('select[data-option-index]'), function (s) { return s.value; }); }
    function build() {
      if (!tpl || !pairsBox) return;
      var rows = pairsBox.querySelectorAll('.es-pair');
      for (var k = rows.length; k < qty; k++) {
        var frag = tpl.content.cloneNode(true);
        var row = frag.querySelector('.es-pair');
        row.querySelector('[data-pair-label]').textContent = pairLabel + ' ' + (k + 1) + ':';
        var prevVals = k > 0 ? rowOptions(rows[0] || pairsBox.querySelector('.es-pair')) : initial;
        row.querySelectorAll('select[data-option-index]').forEach(function (s) {
          var idx = parseInt(s.dataset.optionIndex, 10);
          s.id = root.id + '-p' + k + '-o' + idx;
          var lab = row.querySelector('label[data-for="' + idx + '"]'); if (lab) lab.setAttribute('for', s.id);
          var want = (state[k] && state[k][idx]) || prevVals[idx];
          if (want != null) s.value = want;
        });
        pairsBox.appendChild(row);
      }
      rows = pairsBox.querySelectorAll('.es-pair');
      for (var r = rows.length - 1; r >= qty; r--) rows[r].remove();
      update();
    }
    function update() {
      var rows = pairsBox ? pairsBox.querySelectorAll('.es-pair') : [];
      state = Array.prototype.map.call(rows, rowOptions);
      if (!product) return;
      var total = 0, cmp = 0, valid = true, soldout = false, prices = [];
      var variants = state.map(function (o) { return findVariant(o); });
      if (!variants.length) variants = [findVariant(initial)];
      variants.forEach(function (v) {
        if (!v) { valid = false; return; }
        if (!v.available) soldout = true;
        prices.push(v.price);
        total += v.price; cmp += (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : v.price;
      });
      if (free > 0 && valid) {
        /* free pairs = the cheapest rows, same as Shopify Buy X Get Y */
        cmp = total;
        prices.sort(function (a, b) { return a - b; });
        for (var f = 0; f < free && f < prices.length; f++) total -= prices[f];
      }
      if (priceEl) priceEl.textContent = valid ? formatMoney(total) : '';
      if (cmpEl) { cmpEl.hidden = !(valid && cmp > total); cmpEl.textContent = formatMoney(cmp); }
      if (atc) {
        var ok = valid && !soldout;
        atc.disabled = !ok;
        atc.textContent = !valid ? labels.unavailable : (soldout ? labels.sold : labels.add);
      }
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        free = parseInt(t.dataset.esFree, 10) || 0;
        qty = (parseInt(t.dataset.esTier, 10) || 1) + free; build();
      });
    });
    if (pairsBox) pairsBox.addEventListener('change', update);
    if (atc) atc.addEventListener('click', function () {
      if (!product || atc.disabled) return;
      var map = {}, order = [];
      state.forEach(function (o) { var v = findVariant(o); if (!v) return; if (!map[v.id]) { map[v.id] = 0; order.push(v.id); } map[v.id] += 1; });
      if (!order.length) { var v0 = findVariant(initial); if (v0) { map[v0.id] = qty; order.push(v0.id); } }
      var items = order.map(function (id) { return { id: id, quantity: map[id] }; });
      if (msg) msg.textContent = '';
      atc.disabled = true; atc.setAttribute('aria-busy', 'true');
      json(routes.cartAdd || '/cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) })
        .then(function () { return Cart.open(); })
        .catch(function (e) { if (msg) msg.textContent = e.message || strings.error; })
        .finally(function () { atc.removeAttribute('aria-busy'); update(); });
    });
    build();

    var sticky = root.querySelector('[data-es-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      var seen = false;
      new IntersectionObserver(function (en) {
        en.forEach(function (x) { if (!x.isIntersecting && x.boundingClientRect.top < 0) seen = true; sticky.classList.toggle('is-visible', seen && !x.isIntersecting && x.boundingClientRect.top < 0); });
      }).observe(atc);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-es-product-root]').forEach(initProduct);
    (scope || document).querySelectorAll('[data-es-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
